export class ContactRequiredSubfields {
    constructor(requiredProp) {
        this.Name = false;
        this.Company = false;
        this.Address = false;
        this.Email = false;
        this.Phone = false;

        if (
            requiredProp === undefined ||
            requiredProp === null ||
            requiredProp === false ||
            requiredProp.toLowerCase() === "false"
        ) {
            requiredProp = "";
        } else if (requiredProp.toLowerCase() === "true") {
            // if the required value is boolean, default to name/address/email/phone required, as it used to be
            requiredProp = "naep";
        }
        this.Name = requiredProp.indexOf("n") !== -1;
        this.Company = requiredProp.indexOf("c") !== -1;
        this.Address = requiredProp.indexOf("a") !== -1;
        this.Phone = requiredProp.indexOf("p") !== -1;
        this.Email = requiredProp.indexOf("e") !== -1;
    }
    getPropertyValue() {
        let val = "";
        if (this.Name) val += "n";
        if (this.Company) val += "c";
        if (this.Address) val += "a";
        if (this.Phone) val += "p";
        if (this.Email) val += "e";
        return val;
    }

    hasRequiredSubfields() {
        return this.Name || this.Company || this.Address || this.Phone || this.Email;
    }
}
